import React from 'react';
import jessCoachingPlanHtml from './jessCoachingPlanHtml';

const JessCoachingPlan: React.FC = () => {
  return (
    <iframe
      srcDoc={jessCoachingPlanHtml}
      title="Jess Coaching Plan"
      style={{ width: '100%', height: '100vh', border: 'none' }}
    />
  );
};

export default JessCoachingPlan;
